"use strict";
(function (global) {

  /**
   * Выполняет указанную консольную команду.
   *
   * @tutorial services
   * @function WebAccess.services.commandConsole.exec
   * @param {string} command Выполняемая команда
   * @param {string} args Аргументы команды
   * @return {Deferred} Deferred-объект для управления отложенными вызовами.
   */
  global.commandConsole.exec = function (command, args) {
    return global.call('api/Console.asmx/Execute', { 'command': command, 'arguments': args });
  };

})(window.WebAccess.services);